import { useSyncExternalStore } from "react"
import { createFrameNotifier } from "./createFrameNotifier"

export const createExternalValue = <T>(initialValue: T) => {
    let value = initialValue
    const { notify, subscribe } = createFrameNotifier()

    const get = () => value

    const set = (next: T) => {
        if (Object.is(next, value)) return
        value = next
        notify()
    }

    const update = (updater: (previous: T) => T) => set(updater(value))

    const use = () => useSyncExternalStore(subscribe, get, get)

    return { get, set, update, use }
}
